import React, { useEffect, useState } from 'react';
import './end-of-day.css';
import { goToScreenAndReset } from '../../actions/router';
import { connect } from 'react-redux';
import { START_OF_DAY_SCREEN, TITLE_SCREEN } from '../../constants/routes';
import { IconButton } from '../../components/icon-button';
import { GamesPlayedTracker } from './games-played-tracker';
import { progressDay, exitGame } from '../../actions/active-game';
import classNames from 'classnames';
import { ProgressUpdate } from '../../components/progress-update';
import { Panel } from '../../components/panel';
import { TextButton } from '../../components/text-button';
import { Heading } from '../../components/heading';
import { days } from '../../helpers/time';
import { Paragraph } from '../../components/paragraph';
import { getDaysFeedback } from '../../helpers/active-game';

const EndOfDayScreen = props => {
    const {
        continueToNextDay,
        gamesPlayed,
        day,
        finishWeek,
        overallScores,
        weekFailed,
    } = props;

    const [elementVisible, setElementVisible] = useState('progress-update');
    const [dayFeedback, setDayFeedback] = useState(null);

    const firstPageClasses = classNames({
        'end-of-day__content-first-page': true,
        'end-of-day__content-first-page--visible':
            elementVisible === 'progress-update',
    });

    const gamesPlayedTrackerClasses = classNames({
        'end-of-day__games-played-tracker': true,
        'end-of-day__games-played-tracker--visible':
            elementVisible === 'games-tracker',
    });

    useEffect(() => {
        setDayFeedback(getDaysFeedback(overallScores));
    }, [overallScores, weekFailed]);

    const userMadeItTo =
        days[day] === 'Friday' ? 'the end of the week' : days[day];

    const isEndOfWeek = day === 4 || weekFailed === true;

    return (
        <div className="end-of-day">
            <Panel
                currentPage="end of day"
                withSpacing={true}
                verticalAlign="middle"
            >
                <IconButton
                    onClick={() => setElementVisible('progress-update')}
                    iconName="back"
                    size="small"
                    rotate={180}
                    isDisabled={elementVisible === 'progress-update'}
                />
                <div className="end-of-day__content">
                    <Heading
                        withSpacing={false}
                        colorScheme="dark"
                        headingType="h3"
                    >
                        {isEndOfWeek ? 'End of week' : 'End of day'}
                    </Heading>
                    <div className="end-of-day__content-main">
                        <div className={firstPageClasses}>
                            <Paragraph
                                withSpacing={false}
                                colorScheme="dark"
                                fontWeight="bold"
                            >
                                {weekFailed
                                    ? `Condolences, You only got to ${userMadeItTo}!`
                                    : `Congratulations, you made it to ${userMadeItTo}!`}
                            </Paragraph>
                            <div className="end-of-day__progress-update">
                                <ProgressUpdate
                                    previousScores={{
                                        party: 0,
                                        voters: 0,
                                        media: 0,
                                    }}
                                    updatedScores={overallScores}
                                    titlePosition={'top'}
                                    ariaHideTeardrops={
                                        elementVisible === 'games-tracker'
                                    }
                                />
                            </div>
                            <div>
                                <Paragraph
                                    colorScheme="dark"
                                    withSpacing={false}
                                >
                                    {dayFeedback}
                                </Paragraph>
                            </div>
                        </div>
                        <div className={gamesPlayedTrackerClasses}>
                            <GamesPlayedTracker gamesPlayed={gamesPlayed} />
                        </div>
                    </div>
                    <TextButton
                        onClick={() =>
                            isEndOfWeek ? finishWeek() : continueToNextDay()
                        }
                        text="Continue"
                    />
                </div>
                <IconButton
                    onClick={() => setElementVisible('games-tracker')}
                    iconName="next"
                    size="small"
                    isDisabled={elementVisible === 'games-tracker'}
                />
            </Panel>
        </div>
    );
};

const mapStateToProps = state => {
    return {
        gamesPlayed: state.activeGame.gamesPlayedTracker,
        overallScores: state.activeGame.overallScores,
        day: state.activeGame.currentDay,
        weekFailed: state.activeGame.failed,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        continueToNextDay: () => {
            dispatch(progressDay());
            dispatch(goToScreenAndReset(START_OF_DAY_SCREEN));
        },
        finishWeek: () => {
            dispatch(goToScreenAndReset(TITLE_SCREEN));
            dispatch(exitGame());
        },
    };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(EndOfDayScreen);
export { connected as EndOfDayScreen };
